import { API_endpoints } from "../config";


export const setHolyday = async (formData: { startDate: string, endDate: string, isFullDayClosed: boolean, slotIds: number[] },bookings : (any)[]) => {
    try {
        const response = await fetch(API_endpoints.setHolyday, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({formData,bookings}),
        });
        

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Daten.");
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim Speichern von Feier Daten:", error);
        throw error;
    }
};

